import React, { lazy, Suspense } from 'react';
import BeforeAndAfter from "../components/sections/home/before-and-after-simple/before-and-after-simple";
import CTA from "../components/sections/home/cta";
import FAQ from "../components/sections/home/faq/faq";
import Features1 from "../components/sections/home/features-1";
import Features2 from "../components/sections/home/features-2";
import Features3 from "../components/sections/home/features-3";
import Features4 from "../components/sections/home/features-4";
import Features5 from "../components/sections/home/features-5";

import Pricing from "../components/sections/home/pricing/pricing";
import SaveMoney from "../components/sections/home/save-money";
import Testimonials from "../components/sections/home/testimonial-simple/testimonials-simple";

import Footer from "../components/templates/footer";


import Hero from "../components/sections/home/hero";
import Header from "../components/templates/navbar";
import Work from "../components/sections/home/work";
import Benefit from "../components/sections/home/benefits";
import CompanyLogos from "../components/sections/home/company-logos";



// Lazy load below-the-fold sections with React.lazy
// const Work           = lazy(() => import("../components/sections/home/work"));
// const Benefit        = lazy(() => import("../components/sections/home/benefits"));
// const CompanyLogos   = lazy(() => import("../components/sections/home/company-logos"));
// const BeforeAndAfter = lazy(() => import("../components/sections/home/before-and-after-simple/before-and-after-simple"));
// const Features1      = lazy(() => import("../components/sections/home/features-1"));
// const Features2      = lazy(() => import("../components/sections/home/features-2"));
// const SaveMoney      = lazy(() => import("../components/sections/home/save-money"));
// const Features3      = lazy(() => import("../components/sections/home/features-3"));
// const Features4      = lazy(() => import("../components/sections/home/features-4"));
// const Features5      = lazy(() => import("../components/sections/home/features-5"));
// const Testimonials   = lazy(() => import("../components/sections/home/testimonial-simple/testimonials-simple"));
// const Pricing        = lazy(() => import("../components/sections/home/pricing/pricing"));
// const FAQ            = lazy(() => import("../components/sections/home/faq/faq"));
// const CTA            = lazy(() => import("../components/sections/home/cta"));
// const Footer         = lazy(() => import("../components/templates/footer"));

const Home = () => {
  return (
    <div>
      <Header />
      <Hero />

      {/* Wrap below-the-fold sections in one Suspense boundary */}
      
        <Work />
        <Benefit />
        <CompanyLogos />
        <BeforeAndAfter />
        <Features1 />
        <Features2 />
        <SaveMoney />
        <Features3 />
        <Features4 />
        <Features5 />
        <Testimonials />
        <Pricing />
        <FAQ />
        <CTA />
      <Footer />
    </div>
  );
};

export default Home;
